import { ReactNode } from 'react';
import { Box, Container } from '@mui/material';
import { useGlobals } from 'src/shared/contexts/appContext';

type PageContainerProps = {
  children: ReactNode;
  /** Extra utrymme längst ner, så att man kan rulla innehållet förbi den flytande hjälpknappen. */
  spaceForHelpButton?: boolean;
};

const PageContainer = ({ children, spaceForHelpButton = false }: PageContainerProps) => {
  const { systemMessage } = useGlobals();
  return (
    <Box
      component='main'
      role='main'
      sx={{
        flexGrow: 1,
        height: systemMessage ? `calc(100vh - ${systemMessage.height}px)` : '100vh',
        overflowY: 'scroll',
        overflowX: 'auto',
        backgroundColor: 'background.default',
        mt: systemMessage ? `${systemMessage.height}px` : 0,
      }}
    >
      <Container
        maxWidth='xl'
        sx={{
          pt: 10,
          pb: spaceForHelpButton ? 16 : 6,
          md: {
            pt: 8,
          },
          xs: {
            px: 1,
          },
          px: {
            xl: 6,
            lg: 6,
          },
        }}
      >
        {children}
      </Container>
    </Box>
  );
};

export default PageContainer;
